import React, { forwardRef } from 'react';
import { ResultItem } from './styles';
/**
 * Componente AutocompleteListItem do Design System OLX
 */
export const AutocompleteListItem = forwardRef((props, ref) => React.createElement(ResultItem, Object.assign({}, props, {
  ref: ref
})));
AutocompleteListItem.displayName = 'AutocompleteListItem';